module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-127.7158e1dc.svg";